<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M29 16C29 8.8203 23.1797 3 16 3C8.8203 3 3 8.8203 3 16C3 23.1797 8.8203 29 16 29C20.0487 29 23.6651 27.1492 26.0493 24.2475"
        stroke="var(--icon-color)" stroke-width="1.5" />
    <path
        d="M28.5528 20.1056C28.737 20.4741 29.263 20.4741 29.4472 20.1056L31.6382 15.7236C31.8044 15.3912 31.5627 15 31.191 15H26.809C26.4373 15 26.1956 15.3912 26.3618 15.7236L28.5528 20.1056Z"
        fill="var(--icon-color)" />
    <path d="M20.0879 8.15723L22 9.27392M24.5 10.7033L22 9.27392M22 9.27392V23.0894" stroke="var(--icon-color)" />
    <path d="M14 25.3178L14 16.0378M18.9525 7.57502L16 5.77197L14 6.97777L14 16.0378M14 16.0378H16.9348"
        stroke="var(--icon-color)" />
    <path d="M7 21.3338V10.8679L11 23.5073L11.0046 8.63525" stroke="var(--icon-color)" />
</svg>
